import React from 'react'
import './loadingSpinner.css'

const LoadingSpinner = () => {
  return (
    <div className="loading">
      <div className="lds-dual-ring"></div>
    </div>
  )
}

export default LoadingSpinner
